module.exports = __webpack_public_path__ + "static/media/crosshair.b7368edd.svg";